module.exports = __webpack_public_path__ + "static/img9-58b5ab0961ac331f1c577391250cc3e2.png";